import { Component, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Recording } from '../../../data-models/recording.typings';
import { ModalsService, ConfirmableActions } from '../../../services/modals.service';
import { isNull } from 'util';


@Component({
  selector: 'app-searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.scss']
})
export class SearcherComponent implements AfterViewInit {
  @Input() searchable: string;

  @Output() private newCriteria = new EventEmitter<string>();
  @Output() private cancel = new EventEmitter<boolean>();
  @Output() private focusOut = new EventEmitter<boolean>();
  @ViewChild('Searcher') private searcher: ElementRef;

  constructor(
    private modals: ModalsService,
  ) { }

  ngAfterViewInit() {
    setTimeout(() => this.searcher.nativeElement.focus());
  }

  search() {
    this.newCriteria.emit(this.searchable);
    this.focusOut.emit(true);
  }

  cancelSearch() {
    this.cancel.emit(true);
    this.focusOut.emit(true);
  }


  onFocusOut(event) {
    if (!isNull(event) && !isNull(event.relatedTarget)) {
      const tagId = event.relatedTarget.id;
      const isStillIn = tagId === 'srch-inp' || tagId === 'srch-bt-1' || tagId === 'srch-bt-2';

      if (!isStillIn) {
        this.focusOut.emit(true);
      }
    } else {
      this.focusOut.emit(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/MyRecordings/searcher/searcher.component.ts